export default __webpack_public_path__ + "static/media/under-maintenance-dark.c61400e0.svg";